import { useContext } from 'react';
import { AuthContext } from '../context/auth.context.tsx';
import { RiScales2Fill } from 'react-icons/ri';
import { Navigate } from 'react-router-dom';

const DashboardRedirect = () => {
	const { role } = useContext(AuthContext);

	if (role === 'admin') {
		return <Navigate to="/admin/dashboard" />;
	} else if (role === 'retailer') {
		return <Navigate to="/retailer/dashboard" />;
	} else {
		return <Navigate to="/login" />;
	}

	return (
		<div>
			<RiScales2Fill />
		</div>
	);
};

export default DashboardRedirect;
